import { mergeAll, memoizeWith, identity } from 'ramda';
import {
  ELocale,
  localeDataModules,
  isValidLocale,
  DEFAULT_LOCALE,
} from './locales';

interface ITranslationsObj {
  [id: string]: string;
}

const fetchTranslationsFile = (
  url: string
): Promise<{ [icuId: string]: string }> =>
  fetch(url)
    .then(response => response.json())
    .catch(e => {
      // TODO: send error to sentry
      // eslint-disable-next-line no-console
      console.error(`Translations for ${url} fetching failed:`, e);
      return {};
    });

export const getTranslations = memoizeWith(
  (baseUrl, locale) => baseUrl + locale,
  (
    baseUrl: string,
    locale: ELocale,
    sources: string[]
  ): Promise<ITranslationsObj> =>
    Promise.all(
      sources.map(source =>
        fetchTranslationsFile(`${baseUrl}/${locale}.${source}.json`)
      )
    ).then(mergeAll)
);

export const getLocaleData = memoizeWith(identity, (locale: ELocale) =>
  Promise.resolve(isValidLocale(locale) ? locale : DEFAULT_LOCALE)
    .then(safeLocale => localeDataModules[safeLocale]())
    .then(module => module.default)
);
